export default __webpack_public_path__ + "static/media/keyboardArrowUp.56dcebe0.svg";